(function () {
  'use strict';

  function applyIframeTitles() {
    var merchant = document.getElementById('merchantwidgetiframe');
    if (merchant && !merchant.getAttribute('title')) {
      merchant.setAttribute('title', 'Google customer reviews badge');
    }

    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, function (iframe) {
      if (iframe.getAttribute('title')) {
        return;
      }

      var src = iframe.getAttribute('src') || '';
      if (src.indexOf('youtube.com/embed/') !== -1 || src.indexOf('youtube-nocookie.com/embed/') !== -1 || src.indexOf('player.vimeo.com/video/') !== -1) {
        iframe.setAttribute('title', 'Billiard City video');
      }
    });
  }

  function normalizeAriaControls() {
    var nodes = document.querySelectorAll('[aria-controls]');
    Array.prototype.forEach.call(nodes, function (node) {
      var value = node.getAttribute('aria-controls');
      if (!value || value.charAt(0) !== '#') {
        return;
      }

      var normalized = value.slice(1);
      if (!normalized) {
        return;
      }

      node.setAttribute('aria-controls', normalized);
    });
  }

  function startObserver() {
    applyIframeTitles();
    normalizeAriaControls();

    if (!('MutationObserver' in window) || !document.body) {
      window.setTimeout(function () {
        applyIframeTitles();
        normalizeAriaControls();
      }, 1200);
      return;
    }

    var observer = new MutationObserver(function () {
      applyIframeTitles();
      normalizeAriaControls();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-controls', 'src', 'title']
    });

    window.setTimeout(function () {
      observer.disconnect();
      applyIframeTitles();
      normalizeAriaControls();
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
